function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { useMemo } from 'react';
import { useParams, useNavigate } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@edusense/shared-auth-core';
// OpenAPI hooks: import directly from generated entry to avoid re-export resolution issues under Bazel Vite
// OpenAPI hooks: import directly from generated entry to avoid re-export resolution issues under Bazel Vite
import { useGetProfileByUsername, useUpdateUserProfile } from '@edusense/user-client';
import { ProfileEditPage as EntityProfileEditPage } from '@edusense/entities-user';
// Feature-level ProfileEditPage: wires data + entity UI
var ProfileEditPage = function() {
    var _useParams = useParams(), urlUsername = _useParams.username;
    var _useAuth = useAuth(), user = _useAuth.user, setAuthenticatedState = _useAuth.setAuthenticatedState, token = _useAuth.token;
    var queryClient = useQueryClient();
    var navigate = useNavigate();
    // URL 파라미터가 없으면 로그인 사용자(username) 사용 → /user/edit 지원
    var targetUsername = useMemo(function() {
        var _ref;
        return (_ref = urlUsername !== null && urlUsername !== void 0 ? urlUsername : user === null || user === void 0 ? void 0 : user.username) !== null && _ref !== void 0 ? _ref : '';
    }, [
        urlUsername,
        user === null || user === void 0 ? void 0 : user.username
    ]);
    var _useGetProfileByUsername = useGetProfileByUsername(targetUsername, {
        query: {
            enabled: !!targetUsername
        }
    }), profile = _useGetProfileByUsername.data, isLoading = _useGetProfileByUsername.isLoading;
    var updateProfileMutation = useUpdateUserProfile();
    var _user_id;
    var entityUser = profile ? function() {
        // profile.data에 실제 API 응답이 있음
        var apiResponse = profile.data;
        var bi = apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.basicInfo;
        var pi = apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.profileInfo;
        var _bi_id, _ref, _bi_username, _bi_displayName, _bi_displayName1, _bi_displayName2, _bi_username1, _pi_bio, _pi_location, _pi_website;
        var result = {
            id: String((_ref = (_bi_id = bi === null || bi === void 0 ? void 0 : bi.id) !== null && _bi_id !== void 0 ? _bi_id : user === null || user === void 0 ? void 0 : user.id) !== null && _ref !== void 0 ? _ref : targetUsername),
            username: (_bi_username = bi === null || bi === void 0 ? void 0 : bi.username) !== null && _bi_username !== void 0 ? _bi_username : targetUsername,
            displayName: (_bi_displayName = bi === null || bi === void 0 ? void 0 : bi.displayName) !== null && _bi_displayName !== void 0 ? _bi_displayName : '',
            name: (_bi_displayName1 = bi === null || bi === void 0 ? void 0 : bi.displayName) !== null && _bi_displayName1 !== void 0 ? _bi_displayName1 : '',
            profileImageUrl: bi === null || bi === void 0 ? void 0 : bi.profileImageUrl,
            basicInfo: {
                displayName: (_bi_displayName2 = bi === null || bi === void 0 ? void 0 : bi.displayName) !== null && _bi_displayName2 !== void 0 ? _bi_displayName2 : '',
                profileImageUrl: bi === null || bi === void 0 ? void 0 : bi.profileImageUrl,
                username: (_bi_username1 = bi === null || bi === void 0 ? void 0 : bi.username) !== null && _bi_username1 !== void 0 ? _bi_username1 : targetUsername
            },
            profileInfo: {
                bio: (_pi_bio = pi === null || pi === void 0 ? void 0 : pi.bio) !== null && _pi_bio !== void 0 ? _pi_bio : '',
                location: (_pi_location = pi === null || pi === void 0 ? void 0 : pi.location) !== null && _pi_location !== void 0 ? _pi_location : '',
                website: (_pi_website = pi === null || pi === void 0 ? void 0 : pi.website) !== null && _pi_website !== void 0 ? _pi_website : '',
                coverImageUrl: pi === null || pi === void 0 ? void 0 : pi.coverImageUrl
            }
        };
        console.log('🎯 EntityUser created:', {
            displayName: result.basicInfo.displayName,
            username: result.basicInfo.username,
            fullEntity: result
        });
        return result;
    }() : targetUsername ? {
        id: String((_user_id = user === null || user === void 0 ? void 0 : user.id) !== null && _user_id !== void 0 ? _user_id : targetUsername),
        username: targetUsername,
        displayName: '',
        name: '',
        profileImageUrl: undefined,
        basicInfo: {
            displayName: '',
            profileImageUrl: undefined,
            username: targetUsername
        },
        profileInfo: {
            bio: '',
            location: '',
            website: '',
            coverImageUrl: undefined
        }
    } : undefined;
    var handleSave = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(req, profileImageFile, coverImageFile) {
            var _req_basicInfo, _req_profileInfo, _req_profileInfo1, _req_profileInfo2, _req_basicInfo1, _req_basicInfo2, profileData, requestBody, result, newUsername, updatedUser, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!targetUsername) return [
                            2
                        ];
                        console.log('🚀 Profile save initiated:', {
                            targetUsername: targetUsername,
                            profileData: req,
                            hasProfileImage: !!profileImageFile,
                            hasCoverImage: !!coverImageFile
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            10,
                            ,
                            11
                        ]);
                        // Map Entity ProfileUpdateRequest -> JSON string for backend API
                        // 빈 문자열은 undefined로 전송 (백엔드 검증 통과를 위해)
                        profileData = {
                            displayName: (req === null || req === void 0 ? void 0 : (_req_basicInfo = req.basicInfo) === null || _req_basicInfo === void 0 ? void 0 : _req_basicInfo.displayName) && req.basicInfo.displayName.trim() !== '' ? req.basicInfo.displayName : undefined,
                            bio: (req === null || req === void 0 ? void 0 : (_req_profileInfo = req.profileInfo) === null || _req_profileInfo === void 0 ? void 0 : _req_profileInfo.bio) && req.profileInfo.bio.trim() !== '' ? req.profileInfo.bio : undefined,
                            location: (req === null || req === void 0 ? void 0 : (_req_profileInfo1 = req.profileInfo) === null || _req_profileInfo1 === void 0 ? void 0 : _req_profileInfo1.location) && req.profileInfo.location.trim() !== '' ? req.profileInfo.location : undefined,
                            website: (req === null || req === void 0 ? void 0 : (_req_profileInfo2 = req.profileInfo) === null || _req_profileInfo2 === void 0 ? void 0 : _req_profileInfo2.website) && req.profileInfo.website.trim() !== '' ? req.profileInfo.website : undefined
                        };
                        console.log('🔧 Sending profile data:', profileData);
                        // OpenAPI client expects structured data object for multipart/form-data
                        requestBody = _object_spread({
                            data: {
                                basicInfo: {
                                    username: (req === null || req === void 0 ? void 0 : (_req_basicInfo1 = req.basicInfo) === null || _req_basicInfo1 === void 0 ? void 0 : _req_basicInfo1.username) && req.basicInfo.username.trim() !== '' ? req.basicInfo.username : undefined,
                                    displayName: profileData.displayName
                                },
                                profileInfo: {
                                    bio: profileData.bio,
                                    location: profileData.location,
                                    website: profileData.website
                                }
                            }
                        }, profileImageFile ? {
                            profileImage: profileImageFile
                        } : {}, coverImageFile ? {
                            coverImage: coverImageFile
                        } : {});
                        console.log('🔧 Sending structured profile data:', requestBody);
                        return [
                            4,
                            updateProfileMutation.mutateAsync({
                                userId: (entityUser === null || entityUser === void 0 ? void 0 : entityUser.id) || targetUsername,
                                data: requestBody
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        console.log('✅ Profile update successful');
                        // username이 변경되었으면 새로운 username으로 리다이렉트
                        newUsername = req === null || req === void 0 ? void 0 : (_req_basicInfo2 = req.basicInfo) === null || _req_basicInfo2 === void 0 ? void 0 : _req_basicInfo2.username;
                        if (!(newUsername && newUsername !== targetUsername)) return [
                            3,
                            7
                        ];
                        console.log('🔄 Username changed, redirecting to:', newUsername);
                        if (!(user && targetUsername === user.username && setAuthenticatedState)) return [
                            3,
                            4
                        ];
                        // Auth state 업데이트 - setAuthenticatedState는 자동으로 localStorage를 업데이트함
                        updatedUser = _object_spread_props(_object_spread({}, user), {
                            username: newUsername
                        });
                        // setAuthenticatedState를 사용하여 전체 auth state 업데이트 (localStorage 자동 업데이트)
                        return [
                            4,
                            setAuthenticatedState(updatedUser, token || '', undefined, undefined, undefined, undefined // id_token은 변경 없음
                            )
                        ];
                    case 3:
                        _state.sent();
                        console.log('✅ Updated auth state with new username:', newUsername);
                        _state.label = 4;
                    case 4:
                        // 캐시 무효화 (이전 username과 새 username 모두)
                        return [
                            4,
                            queryClient.invalidateQueries({
                                queryKey: [
                                    'getProfileByUsername',
                                    targetUsername
                                ]
                            })
                        ];
                    case 5:
                        _state.sent();
                        return [
                            4,
                            queryClient.invalidateQueries({
                                queryKey: [
                                    'getProfileByUsername',
                                    newUsername
                                ]
                            })
                        ];
                    case 6:
                        _state.sent();
                        // 새로운 username으로 리다이렉트
                        navigate("/user/".concat(newUsername, "/edit"), {
                            replace: true
                        });
                        return [
                            3,
                            9
                        ];
                    case 7:
                        // username이 변경되지 않았으면 현재 프로필 캐시만 무효화
                        return [
                            4,
                            queryClient.invalidateQueries({
                                queryKey: [
                                    'getProfileByUsername',
                                    targetUsername
                                ]
                            })
                        ];
                    case 8:
                        _state.sent();
                        console.log('🔄 Profile cache invalidated');
                        _state.label = 9;
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        error = _state.sent();
                        console.error('❌ Profile update failed:', error);
                        throw error; // Re-throw so the form can handle the error
                    case 11:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSave(req, profileImageFile, coverImageFile) {
            return _ref.apply(this, arguments);
        };
    }();
    // 데이터가 로딩 중이거나 entityUser가 없으면 로딩 표시
    if (isLoading || !entityUser) {
        return /*#__PURE__*/ React.createElement(EntityProfileEditPage, {
            user: undefined,
            onSave: handleSave,
            onCancel: undefined,
            isLoading: true
        });
    }
    return /*#__PURE__*/ React.createElement(EntityProfileEditPage, {
        user: entityUser,
        onSave: handleSave,
        onCancel: undefined,
        isLoading: false
    });
};
export default ProfileEditPage;
